import React from 'react';
import _get from 'lodash.get';
// import {
//   getOptimizeAbTestingScript,
//   optimizeAbTestingStyle,
// } from 'helpers/analytics/optimizeAbTest';
import { isWap } from 'utils/getParams';
// import { TOI_ONE_LINK_JS } from 'constants';
import { updatePrebidFlag } from 'helpers/ads/redux';
import {
  commonHeadScripts,
  commonHeadScriptsMobile,
} from 'helpers/scripts/headScripts';
//import Loader from 'react-loader';
import RenderIframeWidget from 'routes/iframeWidget/RenderIframeWidget';
import {
  setAdsConfig,
  setSubSecNavFrmUrl,
  checkJarvisAdsConfigForSS,
} from 'helpers/ads/utils';
// import loadLayoutData from 'reduxUtils/modules/layout';
import { loadLayoutDataList } from 'reduxUtils/modules_v2/layout';
import {
  getSectionsListFromBreadCrumb,
  getCustomDimension8,
  getQueryParams,
  fireGA4Script,
} from 'utils/common';
import { loadPageAdCode } from 'helpers/ads/revenueRedux';
import {
  loadVideosData,
  clearVideosData,
  // loadHistoryData,
  // getWatchLaterData,
  getPathUrl,
  loadVideoListData,
  loadLinkListsData,
} from '../../redux';

import Videos from '../../Videos';
import VideosListing from './VideosListing';

const pageName = 'section_listing';

async function action(context) {
  const dataPromiseArray = [];
  if (context.path === '/etimes/videos') {
    context.path = '/videos/etimes';
    context.pathname = '/videos/etimes';
    context.params = { '0': 'etimes' };
  }

  const localParams = { 0: context.path };

  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState(),
    sectionsNameList = [],
    cd8 = '';
  const isWapView = isWap(context.query) || state.isMobile;
  const isAppView = state.isFrmapp;
  const isEtimesPages = [
    '/videos/lifestyle',
    '/videos/tv',
    '/videos/lifestyle',
    '/videos/etimes',
    '/videos/beauty-pageants',
    '/videos/etimes/bollywood',
  ];

  const isNewVideoPages = [
    '/videos/',
    '/videos',
    '/videos/business/financial-literacy',
    '/videos/sports',
    '/videos/tech',
    '/videos/motion-graphics',
    '/videos/budget',
    '/videos/trending-videos',
    '/videos/featured-videos',
    '/videos/toi-newspoint',
    '/videos/toi-originals',
    '/videos/international',
    '/videos/narrative-wc-T20-spl',
    '/videos/bollywood',
    '/videos/narrative-election-spl',
    '/videos/dance-of-democracy',
    '/videos/elections/lok-sabha-election',
    '/videos/news',
    '/videos/viral-videos',
    '/videos/toi-in-depth',
    '/videos/times-property',
    '/videos/business',
    '/videos/budget',
    '/videos/lifestyle/health-fitness',
    '/videos/tech',
    '/videos/motion-graphics',
    '/videos/astrology',
    '/videos/coronavirus',
    '/videos/auto',
    '/videos/top-videos',
    '/videos/global-pulse',
  ];
  const isEtimes =
    isEtimesPages.includes(context.pathname) ||
    context.pathname.includes('/videos/entertainment') ||
    context.pathname.includes('/videos/beauty-pageants') ||
    context.pathname.includes('/videos/lifestyle') ||
    context.pathname.includes('/videos/tv');

  const isNewVideoPath =
    isNewVideoPages.includes(context.pathname) ||
    isEtimes ||
    context.pathname.includes('/videos/city') ||
    context.pathname.includes('/videos/auto') ||
    context.pathname.includes('/videos/business') ||
    context.pathname.includes('/videos/sports');
  const newParams = {
    ...localParams,
    curpg: 1,
    fullPath: context.path,
    isWapView,
    templateName: 'videos',
    isAppView,
    // skipSubSections: isWapView,
  };
  const isPrime = !!state.isPrime;
  const { pathname } = context;
  let showMiniTv = true;
  let hideAdCude = false;
  if (pathname && pathname.includes('/cryptocurrency')) {
    showMiniTv = false;
    hideAdCude = true;
  }

  // Route data calls start
  let contextParams = context.params;
  contextParams = { ...contextParams, isPrime, isNewVideoPath };

  const { default: Layout } = isEtimes
    ? await import(/* webpackChunkName: "etimeslayout" */ 'components_v2/desktop/ETimesLayout')
    : await import(/* webpackChunkName: "toilayout" */ 'components_v2/desktop/Layout');

  const isHistoryPage = contextParams && contextParams[0] === 'history';
  const isWatchLaterPage = contextParams && contextParams[0] === 'watch-later';
  if (isHistoryPage) {
    if (typeof window === 'object') {
      context.store.dispatch(clearVideosData(contextParams));
      // context.store.dispatch(loadHistoryData());
    }
  } else if (isWatchLaterPage) {
    if (typeof window === 'object') {
      context.store.dispatch(clearVideosData(contextParams));
      // context.store.dispatch(getWatchLaterData(contextParams, 5));
    }
  } else if (
    (context.clientRouting || !state.videos.data) &&
    getPathUrl(contextParams) !== _get(state, 'videos.data.url', undefined)
  ) {
    if (context.clientRouting) {
      context.store.dispatch(clearVideosData(contextParams));
      context.store.dispatch(loadVideoListData(contextParams, isWapView));
      context.store.dispatch(loadVideosData(contextParams, isWapView));
      context.store.dispatch(loadLinkListsData(isWapView));
    } else {
      dataPromiseArray.push(
        context.store.dispatch(loadVideosData(contextParams, isWapView)),
        context.store.dispatch(loadVideoListData(contextParams, isWapView)),
        context.store.dispatch(loadLinkListsData(isWapView)),
      );
    }
  }

  if (!isPrime && typeof window === 'undefined') {
    let jpiconfig = {
      Tmpl_SCN: 'Listing',
      platform: isWapView ? 'mweb' : 'web',
      Channel: 'toi',
    };
    const navs = setSubSecNavFrmUrl(pathname, 0);
    jpiconfig = { ...jpiconfig, ...navs };
    dataPromiseArray.push(context.store.dispatch(loadPageAdCode(jpiconfig)));
  }

  // Route data calls end

  if (typeof window !== 'undefined' && !isWatchLaterPage) {
    // context.store.dispatch(getWatchLaterData(contextParams, 50));
  }

  if (!state.footer_v2.data || !state.header.data) {
    dataPromiseArray.push(
      context.store.dispatch(loadLayoutDataList(newParams)),
    );
  }

  // wait for responses on server side
  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
  }

  if (typeof window !== 'undefined') {
    let categoryForGA = 'WEB';
    if (isWapView) {
      categoryForGA = 'mWEB';
    }
    categoryForGA += `-CL-${window.location.pathname}`;
    window.categoryForGA = categoryForGA;
    window.categoryForSearchGA = isWapView ? 'WAP-TOI-Video' : 'WEB-TOI-Video';

    if (Array.isArray(contextParams) && contextParams.length > 0) {
      const sectionsList = contextParams['0'].split('/');
      if (sectionsList && sectionsList.length > 1) {
        setAdsConfig({ subSection: sectionsList[1] });
      }
    }
  }

  // get updated state
  state = context.store.getState();
  if (
    state.navigation &&
    state.navigation.data &&
    state.navigation.data.breadCrumbs
  ) {
    sectionsNameList = getSectionsListFromBreadCrumb(
      state.navigation.data.breadCrumbs,
    );
    cd8 = getCustomDimension8(sectionsNameList);
  }

  let status = 200;
  const title = 'Get Latest News Updates from The Times Of India';
  let dataAvailable = !!state.videos.data;
  const forcedErrorStatus =
    state.liveblog && state.liveblog.forcedErrorStatus
      ? state.liveblog.forcedErrorStatus
      : null;
  // const dataAvailable = false;

  /*
  state.homeJson = homejson;
  state.categoryOneJson = categoryOneJson;
  state.categoryTwoJson = categoryOneJson;
  */
  if (
    typeof window === 'undefined' &&
    pathname &&
    (pathname.includes('/videos/entertainment') ||
      pathname.includes('/videos/etimes') ||
      pathname.includes('/videos/tv') ||
      pathname.includes('/videos/lifestyle')) &&
    !isNewVideoPath
  ) {
    status = 404;
  }

  if (
    typeof window === 'undefined' &&
    !dataAvailable &&
    !isHistoryPage &&
    !isWatchLaterPage
  ) {
    status = 404;
  }

  if (forcedErrorStatus) {
    status = forcedErrorStatus;
    dataAvailable = false;
  }

  /*
  let videosData = state.homeJson;
  if(context.params.hasOwnProperty(0)) {
    videosData = state.categoryOneJson;
  }
  */
  // set color theme

  const getComponent = pageTitle => {
    if (
      typeof window === 'undefined' &&
      !dataAvailable &&
      !isWatchLaterPage &&
      !isHistoryPage
    ) {
      return (
        <div>
          Something went wrong. Click{' '}
          <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
        </div>
      );
    }

    const prebidObj = _get(state, `common.siteConfig.prebid.templates.videos`);
    const url = _get(state, 'url');
    context.store.dispatch(updatePrebidFlag(prebidObj));

    const widgetName = getQueryParams('widget', { href: url });
    if (widgetName) {
      return <RenderIframeWidget isWapView={isWapView} url={url} />;
    }
    const pageRefreshTime = _get(
      state,
      `common.siteConfig.abexperiment.pagerefresh.refreshminutes.videos`,
      0,
    );

    /*
    return <Videos isWapView={isWapView} />;
    */
    return (
      <Layout
        layoutClass="layout_type_2"
        title={pageTitle}
        params={newParams}
        query={Object.keys(context.query).length ? context.query : {}}
        layoutType=""
        hideStickyBackToTop
        rhs={false}
        adPosition="masthead"
        showAdBlockerInINEU
        showTimesTop10
        // hideAdBlockerDetector //comment this to add adblocker
        refreshFBNAd
        hideBreadcrumAtBottom
        pageType="VideoListing"
        pageTypeWithVersion="VideoListing"
        hideAds={false}
        showCovid19PopUp
        disablePopUpManager
        msid={newParams.msid}
        showMiniTv={showMiniTv}
        hideAdCude={hideAdCude}
        desktopAdCode={_get(
          state,
          'revenue.data.ads.layout.masthead',
          undefined,
        )}
        gutterAdCode={_get(state, 'revenue.data.ads.layout.gutter', undefined)}
        // overRideClass={s.miniTvtopband}
        bannerMsid={_get(state, 'homepage_etimes.data.bannerMsid', '')}
        // navigation={state.header.data && state.header.data.navigation}
        // showTopSearchAtTop={
        //   topSearches && topSearches.items && topSearches.items.length
        // }
        hideAffiliatesFloatingNudge
        pathname={context.pathname}
      >
        {isNewVideoPath ? (
          <VideosListing
            hpData={state.videos.data}
            navigation={state.header.data && state.header.data.navigation}
            isPrime={state.isPrime}
            campaigns={_get(state, 'common.siteConfig.revenue', '')}
            topSearches={state.commonData?.data?.topSearches}
          />
        ) : (
          <Videos
            isWapView={isWapView}
            isHistoryPage={isHistoryPage}
            isWatchLaterPage={isWatchLaterPage}
            contextParams={contextParams}
            refreshTime={parseFloat(pageRefreshTime, 10)}
          />
        )}
      </Layout>
    );
  };
  const getAdsTargetingObj = () => {
    const metaKeywords = _get(
      state,
      !isNewVideoPath
        ? 'videos.videoListData.seoData.keywords'
        : 'videos.data.seo',
      '',
    );
    const contentUrl = pathname;
    const navKeyObj = setSubSecNavFrmUrl(contentUrl, -1);
    if (
      navKeyObj &&
      Object.keys(navKeyObj).length > 0 &&
      navKeyObj.LastSubSCN === 'online-schooling'
    ) {
      navKeyObj.SubSCN = navKeyObj.LastSubSCN;
      navKeyObj.SubSCN = navKeyObj.SubSCN.replace('-', ' ');
      navKeyObj.LastSubSCN = '';
    }
    const adConfig = {
      Tmpl_SCN: 'listing',
      Channel: isEtimes ? 'etimes' : 'toi',
      ...navKeyObj,
    };
    if (typeof window === 'undefined') {
      checkJarvisAdsConfigForSS({
        jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
        isWapView,
        ...adConfig,
      });
    }
    return {
      Meta_Keywords: metaKeywords,
      ...adConfig,
    };
  };
  if (typeof window !== 'undefined') {
    fireGA4Script();
  }
  const afterAdsScript = [];
  // if (isWapView) {
  //   afterAdsScript.push(TOI_ONE_LINK_JS);
  // }
  const isNewGam = _get(state, 'revenue.data.widgets.isNewGam', false);

  const getChunkName = async () => {
    const val = isEtimes ? 'etimeslayout' : 'toilayout';
    return val;
  };

  // const gtmIDForOptimisely = isWapView ? ['GTM-54ZCD8R'] : null;
  return {
    chunks: ['videosdesktop', await getChunkName()],
    title,
    seoData: _get(
      state.videos,
      !isNewVideoPath ? 'videoListData.seoData' : 'data.seo',
      {},
    ),
    status,
    component: getComponent(title),
    maxAge:
      state.videos && state.videos.videoListData
        ? state.videos.videoListData.maxAge
        : 300,
    gaData: {
      dimension9: pageName,
      dimension8: cd8,
    },
    adsTargetingObj: getAdsTargetingObj(),
    useEtimesFavicon: isEtimes,
    preconnectDomains: ['//tpapi.timespoints.com', '//toifeeds.indiatimes.com'],
    // gtmIDList: gtmIDForOptimisely,
    headTags: isWapView
      ? [
          ...commonHeadScriptsMobile,
          // <style
          //   dangerouslySetInnerHTML={{ __html: optimizeAbTestingStyle }}
          // />,
          // <script
          //   dangerouslySetInnerHTML={{
          //     __html: getOptimizeAbTestingScript(gtmIDForOptimisely),
          //   }}
          // />,
        ]
      : [...commonHeadScripts],
    afterAdsScript,
    isNewGam,
  };
}

export default action;
